import type { ElementType, HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";
import s from "./card.module.css";

export interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
}

export function Card({ as: Tag = "section", className, ...rest }: CardProps) {
  return <Tag className={cx(s.card, className)} {...rest} />;
}

export interface CardHeaderProps {
  title: ReactNode;
  titleId?: string;
  subtitle?: ReactNode;
  /** Right-hand content: a "View all" link, a button or a legend. */
  action?: ReactNode;
}

export function CardHeader({ title, titleId, subtitle, action }: CardHeaderProps) {
  return (
    <div className={s.head}>
      <div>
        <h2 id={titleId} tabIndex={titleId ? -1 : undefined}>{title}</h2>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {action ? <div className={s.right}>{action}</div> : null}
    </div>
  );
}

/** "View all". Pass `as={Link} to="/members"` from the app to route client-side. */
export function ViewAll({ as: Tag = "a", className, children = "View all", ...rest }: { as?: ElementType; className?: string; children?: ReactNode } & Record<string, unknown>) {
  return <Tag className={cx(s.viewAll, className)} {...rest}>{children}</Tag>;
}

export function CardFooter({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cx(s.footer, className)}>{children}</div>;
}
